export enum PortalRoutes {
  MAIN = 'main',
  INVITE = 'invite',
  UNSUBSCRIBE = 'unsubscribe',
}

export enum PortalRouteParams {
  SUGGESTED_ACCOUNT_ID = 'account-id',
}
